<span mat-dialog-title>{{ 'ACCOUNT.EMAIL_SENT.TITLE' | translate }}</span>
<div mat-dialog-content>{{ 'ACCOUNT.EMAIL_SENT.INFO' | translate : { email: emailState$ | async } }}</div>
<div mat-dialog-actions>
  <!--todo: implement logic-->
  <a mat-flat-button mat-dialog-close color="primary" routerLink="/login">
    {{ 'ACCOUNT.EMAIL_SENT.BACK_TO_LOGIN' | translate }}
  </a>
</div>
